import * as form from '../form';

export const identificationContacts = (data = {}) => {
  const phoneNumbers = ((data?.PhoneNumbers || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Telephone: form.telephone(xitem.Telephone),
      },
    };
  });

  const emails = ((data?.Emails || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Email: form.email(xitem.Email),
      },
    };
  });
  return {
    HomeEmail: form.email(data?.HomeEmail), // TODO: Remove after SF no longer used
    WorkEmail: form.email(data?.WorkEmail), // TODO: Remove after SF no longer used
    PhoneNumbers: form.collection(phoneNumbers),
    Emails: form.collection(emails) // PVQ Only
  };
};
